import { BookingCalendarEvent } from "@models/services/booking";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  calendarEvents: BookingCalendarEvent[];
  tempEvents: BookingCalendarEvent[];
};

const initialState: initialType = {
  calendarEvents: [],
  tempEvents: [],
};

type bookingCalendarSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setCalendarEvents: bookingCalendarSliceReducer<BookingCalendarEvent[]> = (
  state,
  action
) => {
  state.calendarEvents = action.payload;
};

const setTempEvents: bookingCalendarSliceReducer<BookingCalendarEvent[]> = (
  state,
  action
) => {
  state.tempEvents = action.payload;
};

export const bookingCalendarSlice = createSlice({
  initialState,
  name: "bookingCalendar",
  reducers: {
    setCalendarEvents,
    setTempEvents,
  },
});

export default bookingCalendarSlice;
